import React from "react";
import "./Custom_Confirm_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Modal_Heading/Modal_Heading";
import Remove_Points_Modal_Frame from "./Custom_Confirm_Modal_Frame/Custom_Confirm_Modal_Frame";

function Custom_Confirm_Modal(props) {
  return (
    <>
      <section>
        <Modal
          {...props}
          className=" Add_Points_Modal modal_holder Custom_Confirm_Modal"
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal_Heading modalHeading={props.heading} />
          <div className="modal-body-holder">
            {/* <Remove_Points_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="delete-text-holder">
                        <p>{props.title}</p>
                      </div>
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="row">
                    <div className=" col-md-6 col-sm-6 col-6">
                      <Button className="search-btn" onClick={props.onHide}>
                        No
                      </Button>
                    </div>

                    <div className=" col-md-6 col-sm-6 col-6">
                      <Button className="reset-btn " type="button" onClick={props?.handleFunction}>
                        Yes
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
      </section>
    </>
  );
}

export default Custom_Confirm_Modal;
